import { useAccount } from 'dashboard/composables/useAccount';
import { usePolicy } from 'dashboard/composables/usePolicy';
import { MODULE_PERMISSION_BY_KEY } from 'dashboard/constants/permissions.js';
import { isModuleEnabledForAccount } from 'dashboard/helper/featureModules';

/**
 * Visibilidade de um módulo nativo: liberado para a empresa no Super Admin
 * e permitido para a função do usuário (funções personalizadas precisam da
 * permissão do módulo).
 */
export function useFeatureModules() {
  const { currentAccount } = useAccount();
  const { checkPermissions } = usePolicy();

  const isModuleEnabled = moduleKey => {
    if (!isModuleEnabledForAccount(currentAccount.value, moduleKey)) {
      return false;
    }

    const rolePermission = MODULE_PERMISSION_BY_KEY[moduleKey];
    const required = rolePermission
      ? ['administrator', 'agent', rolePermission]
      : ['administrator', 'agent'];
    return checkPermissions(required);
  };

  return { isModuleEnabled };
}
